export enum StatusCategoryEnum {
  NotStarted = 'not_started',
  ToDo = 'todo',
  InProgress = 'in_progress',
  Done = 'done',
}
